import React from 'react';
import { PlusIcon, Trash2Icon } from 'lucide-react';
import { PayItem } from '../../../types/hr';
type PayItemsEditorProps = {
  label: string;
  items: PayItem[];
  types: {
    id: string;
    name: string;
  }[];
  onChange: (items: PayItem[]) => void;
  addLabel: string;
};

/** Fixed monthly allowances or deductions assigned to an employee. */
export function PayItemsEditor({
  label,
  items,
  types,
  onChange,
  addLabel
}: PayItemsEditorProps) {
  const used = new Set(items.map(item => item.typeId));
  const available = types.filter(type => !used.has(type.id));
  const update = (index: number, patch: Partial<PayItem>) => onChange(items.map((item, i) => i === index ? {
    ...item,
    ...patch
  } : item));
  return <fieldset data-id="element-1331" data-mp="1xqantloyh0mh">
      <legend className="mb-2 text-sm font-medium text-slate-800" data-id="element-1332" data-mp="1xru61hu69lqw">{label}</legend>
      {items.length === 0 && <p className="mb-2 text-sm text-slate-500" data-id="element-1333" data-mp="8c4jrfgaxncq">None assigned.</p>}
      <ul className="space-y-2" data-id="element-1334" data-mp="3db53jpa3qaz">
        {items.map((item, index) => <li key={`${item.typeId}-${index}`} className="flex items-center gap-2" data-id="element-1335" data-mp="3fdtoyhkugkx3" data-mpi={index}>
            <label className="sr-only" htmlFor={`${label}-type-${index}`} data-id="element-1336" data-mp="3fbz0itad6ao9">Type</label>
            <select id={`${label}-type-${index}`} value={item.typeId} onChange={e => update(index, {
          typeId: e.target.value
        })} className="min-w-0 flex-1 rounded-md border border-slate-300 bg-white p-2 text-sm focus:border-blue-500 focus:outline-none focus:ring-1 focus:ring-blue-500" data-id="element-1337" data-mp="3kd68ascib9ux">
              {types.filter(type => type.id === item.typeId || !used.has(type.id)).map(type => <option key={type.id} value={type.id} data-id="element-1338" data-mp="byee5e4n67aw">{type.name}</option>)}
            </select>
            <label className="sr-only" htmlFor={`${label}-amount-${index}`} data-id="element-1339" data-mp="guv3gbnkurpk">Monthly amount (K)</label>
            <div className="relative w-36" data-id="element-1340" data-mp="2dpria0yscb5w">
              <span className="pointer-events-none absolute left-2.5 top-1/2 -translate-y-1/2 text-sm text-slate-500" data-id="element-1341" data-mp="2dqsrs105kpli">K</span>
              <input id={`${label}-amount-${index}`} type="number" min="0" step="0.01" value={item.amount || ''} onChange={e => update(index, {
            amount: Number(e.target.value)
          })} className="w-full rounded-md border border-slate-300 py-2 pl-6 pr-2 text-right text-sm tabular-nums focus:border-blue-500 focus:outline-none focus:ring-1 focus:ring-blue-500" data-id="element-1342" data-mp="2ambn55xy1sxb" />
            </div>
            <button type="button" onClick={() => onChange(items.filter((_, i) => i !== index))} className="rounded-md p-2 text-slate-400 hover:bg-red-50 hover:text-red-600" aria-label="Remove" data-id="element-1343" data-mp="2on5udl999nue">
              <Trash2Icon className="h-4 w-4" data-id="element-1344" data-mp="2ybw81udnr098" />
            </button>
          </li>)}
      </ul>
      {available.length > 0 && <button type="button" onClick={() => onChange([...items, {
      typeId: available[0].id,
      amount: 0
    }])} className="mt-2 inline-flex items-center gap-1 text-sm font-medium text-blue-700 hover:underline" data-id="element-1345" data-mp="3ccqgue4mb38f">
          <PlusIcon className="h-4 w-4" aria-hidden="true" data-id="element-1346" data-mp="3qzp6q4nttpl1" /> {addLabel}
        </button>}
    </fieldset>;
}